<template>
  <div>
    <div class="hm-headline">
      <span class="headline">会员营销</span>
      <span class="subhead">营销原因管理</span>
    </div>
    <el-card>
      <div class="table">
        <div class="flex table-panel">
          <el-input
            v-model="reason"
            clearable
            placeholder="请输入营销原因"
            size="small"
            class="mr10"
          ></el-input>
          <el-button
            type="primary"
            size="small"
            @click="submit"
            :disabled="reason === ''"
            >新增</el-button
          >
        </div>
        <el-table border :data="marketingReasonList" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
              label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="oper_id"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="create_time"
            label="操作时间"
            width="200"
          >
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="deleteReason(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      dialogVisible: false,
      reason: ""
    };
  },
  computed: {
    setReasonCode() {
      return this.$store.state.marketing.setReasonCode;
    },
    removeReasonCode() {
      return this.$store.state.marketing.removeReasonCode;
    },
    marketingReasonList() {
      return this.$store.state.marketing.marketingReasonList;
    }
  },
  watch: {
    setReasonCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功,",
          type: "success"
        });
      }
      this.$store.commit("setMarketingReson", "");
      this.$store.dispatch("queryMarketingReason");
    },
    removeReasonCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功,",
          type: "success"
        });
      }
      this.$store.commit("removeMarketingReson", "");
      this.$store.dispatch("queryMarketingReason");
    }
  },
  mounted() {
    this.$store.dispatch("queryMarketingReason");
  },
  methods: {
    submit() {
      this.$store.dispatch("setMarketingReson");
    },
    deleteReason(id) {
      this.$store.dispatch("removeMarketingReson", {
        id
      });
    }
  }
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: center;
}
</style>
